import BindingPerComponent from "./index.vue";
import Vue from "vue";

let instance;

const BindingPerConstructor = Vue.extend(BindingPerComponent);

instance = new BindingPerConstructor({
	el: document.createElement("div")
});

const bindingPer = {
	open (options = {}) {
		const { infinite, chooseType, section, callback, cancel } = options;

		if (infinite != undefined) {
			instance.infinite = infinite;
		}
		if (section) {
			instance.section = section;
		}
		if (chooseType) {
			instance.chooseType = chooseType;
		}
		if (callback) {
			instance.$on("callback", callback);
		}
		if (cancel) {
			instance.$on("cancel", cancel);
		}

		document.body.appendChild(instance.$el);

		instance.showDialog();
	}
}

export default {
	install () {
		Vue.prototype.$bindingPer = bindingPer;
	}
}
